import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Écran "vous n'avez pas accès" — affiché quand le backend renvoie
 * 401/403 ou que la requête réseau a planté.
 */
const DossierUnauthorizedView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-mcdm-beige-100 flex justify-center items-center">
      <div className="text-center p-4">
        <p className="text-lg font-semibold">Vous n'avez pas accès à ce dossier.</p>
        <button
          onClick={() => navigate('/dossiers')}
          className="mt-4 px-4 py-2 bg-mcdm-vert-300 text-white rounded hover:bg-mcdm-vert-400"
        >
          Retour à la liste des dossiers
        </button>
      </div>
    </div>
  );
};

export default DossierUnauthorizedView;
